const { registerLinkResolver } = require("gatsby-source-prismic-graphql");
const linkResolver = require("./src/utils/linkResolver");
require("./src/include/bootstrap.min.css");
const Popper = require("popper.js");
require("./src/include/bootstrap.min.js");
const React = require("react");
const {
	WrapPageContextProvider,
} = require("./src/components/Layout/ContextWrapper");

registerLinkResolver(linkResolver);

// eslint-disable-next-line react/display-name
exports.wrapPageElement = ({ element, props }) => {
	const fromNav = props.location.state ? props.location.state.fromNav : false;

	return (
		<WrapPageContextProvider
			currentPath={props.location.pathname}
			currentHash={props.location.hash}
			fromNav={fromNav}
		>
			{element}
		</WrapPageContextProvider>
	);
};
